<template>
  <svg
    :width="`${width}px`"
    :height="`${height}px`"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.3007 12.4133C4.06033 12.6497 3.67063 12.6497 3.43027 12.4133C3.18991 12.177 3.18991 11.7938 3.43027 11.5575L7.0485 8L3.43027 4.44249C3.18991 4.20617 3.18991 3.823 3.43027 3.58668C3.67063 3.35035 4.06033 3.35035 4.3007 3.58668L7.91892 7.14418L11.6993 3.42725C11.9397 3.19092 12.3294 3.19092 12.5697 3.42725C12.8101 3.66357 12.8101 4.04674 12.5697 4.28306L8.78935 8L12.5697 11.7169C12.8101 11.9533 12.8101 12.3364 12.5697 12.5728C12.3294 12.8091 11.9397 12.8091 11.6993 12.5728L7.91892 8.85582L4.3007 12.4133Z"
      :fill="color"
    />
  </svg>
</template>

<script src="./index.js" />
